import { useQuery } from 'react-query';

import { KimThread } from '../../../../backend/src/matter/subset/thread/kim-thread.entity';
import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

interface UseGetKimThreadOptions {
  refetchInterval?: number | false;
}

export const useGetKimThread = (
  matterId?: string,
  subsetId?: string,
  threadId?: string,
  options?: UseGetKimThreadOptions,
) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<KimThread, ApiError>(
    [QueryEntity.KimThread, { threadId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}`,
        fetchConfigGET,
      );
      if (!res.ok) {
        const error = await res.json();
        throw new ApiError(res.status, error.message);
      }
      return res.json();
    },
    {
      enabled: !!matterId && !!subsetId && !!threadId,
      refetchOnWindowFocus: false,
      refetchInterval: options?.refetchInterval ?? false,
      retry: (failureCount, error) => error.code !== 404 && failureCount < 3,
    },
  );
};
